import { Overlay, OverlayContainer, ViewportRuler } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { Location } from '@angular/common';
import { Component, Injector } from '@angular/core';
import { PageConfigurationProvider } from '@app/finxone-web-frontend/app/Modules/zones/page-configuration.provider';
import { AccountService } from '@app/finxone-web-frontend/app/lib/services/account-service/account-service.service';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import {
  buildHandleBarModel,
  filterIfHandlebarNotRendered,
} from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { IconCacheService } from '@finxone-platform/shared/services';
import {
  BaseCssProperties,
  ProviderClass,
  UiZoneWidgetConfig,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import Handlebars from 'handlebars';
import { Subject, takeUntil } from 'rxjs';
import { OverlayWidgetComponent } from '../../overlay/overlay';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-forward-button',
  templateUrl: './forward-widget.component.html',
  styleUrls: ['./forward-widget.component.scss'],
})
export class ForwardButtonComponent extends OverlayWidgetComponent<ForwardButtonComponent> {
  @AutoDestroy private destroy$: Subject<void> = new Subject<void>();
  public widgetConfig: UiZoneWidgetConfig;
  public activePageIndex!: number;
  public backgroundShape: string;
  public icon: string;
  public iconSize?: baseCssConfigStyle;
  public text = '';
  public renderedContent = '';

  constructor(
    configService: ConfigService,
    dataIn: ProviderClass<any>,
    private location: Location,
    overlay: Overlay,
    injector: Injector,
    _viewportRuler: ViewportRuler,
    _platform: Platform,
    _overlayContainer: OverlayContainer,
    public pageConfig: PageConfigurationProvider,
    private countriesCurrenciesService: CountriesCurrenciesService,
    private iconCacheService: IconCacheService,
    private accountService: AccountService,
    private store: Store,
  ) {
    super(
      dataIn,
      overlay,
      injector,
      ForwardButtonComponent,
      _viewportRuler,
      _platform,
      _overlayContainer,
      configService,
    );
    if (this.dataIn != undefined && this.dataIn != null) {
      this.widgetConfig = this.dataIn.widgetConfig;
      this.attri = this.dataIn.attri;
      this.icon = this.dataIn.attri?.widgetProperties?.icon ?? 'arrow-right-jamboo';
      this.backgroundShape = this.widgetConfig.attributes.widgetProperties['backgroundShape'];
      this.onLoadWidgetContent();
    }

    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.BOX_SHADOW,
      BaseCssProperties.TEXTALIGN,
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.COLOR,
      BaseCssProperties.V_ALIGN,
      BaseCssProperties.BORDER,
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      BaseCssProperties.TEXTALIGN,
      BaseCssProperties.FONT_SIZE,
      BaseCssProperties.TEXT_ITALIC,
      BaseCssProperties.TEXT_BOLD,
      BaseCssProperties.TEXT_UNDERLINE,
      BaseCssProperties.TEXT_FONT_STYLE,
    ]);

    this.iconSize = this.configService.getSpecificBaseCssStyle(this.attri, [BaseCssProperties.ICON_SIZE]);

    this.handleBackgroundShape(this.backgroundShape);
  }

  private onLoadWidgetContent(): void {
    this.text = this.dataIn.attri?.widgetProperties?.textContent ?? '';
    const template = Handlebars.compile(this.text);
    buildHandleBarModel(
      this.store,
      this.text,
      this.countriesCurrenciesService,
      this.iconCacheService,
      this.accountService,
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.renderedContent = filterIfHandlebarNotRendered(template(model));
      });
  }

  public handleAction() {
    this.location.forward();
  }

  public handleBackgroundShape(shape: string) {
    switch (shape) {
      case 'circle':
        this.contentStyle['border-bottom-left-radius'] = '50%';
        this.contentStyle['border-top-left-radius'] = '50%';
        this.contentStyle['border-bottom-right-radius'] = '50%';
        this.contentStyle['border-top-right-radius'] = '50%';
        break;
      case 'square':
      case 'rectangle':
        this.contentStyle['border-bottom-left-radius'] = '0%';
        this.contentStyle['border-top-left-radius'] = '0%';
        this.contentStyle['border-bottom-right-radius'] = '0%';
        break;
    }
  }
}
